import React, { useState, useEffect } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap"
import { FaRegEyeSlash } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux" // Import useSelector
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
import LeaveForm from "./LeaveForm"
import API from "../../api/axios"

const LeaveTable = props => {
  const navigate = useNavigate()
  const [leaveData, setLeaveData] = useState([])

  // Using useSelector to get closed days (holidays, weekends) from the Redux store
  const closedDays = useSelector(state => state.clinicSetting?.leaveDays) || []

  // This function calculates the number of working days (excluding closed days)
  const isWorkingDay = dayName => !closedDays.includes(dayName)

  const getWorkingDays = (start, end) => {
    let count = 0
    const currentDate = new Date(start)
    const endDate = new Date(end)
    const dayNames = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ]

    while (currentDate <= endDate) {
      const dayIndex = currentDate.getDay()
      const dayName = dayNames[dayIndex]

      if (isWorkingDay(dayName)) {
        count++
      }
      currentDate.setDate(currentDate.getDate() + 1)
    }

    return count
  }

  // Fetching leave data from the API
  const fetchLeaves = async () => {
    try {
      const authToken = localStorage.getItem("authToken")
      const response = await API.get("/leaves", {
        headers: {
          Authorization: `Bearer ${authToken}`,
          "Content-type": "application/json",
        },
      })
      setLeaveData(response.data)
      props.setBreadcrumbItems("Leave Table", breadcrumbItems)
    } catch (error) {
      console.error("Error fetching leaves:", error)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Leaves", link: "#" },
  ]
  // Function to handle clicking on the edit button for a leave
  const handleEditClick = leave => {
    console.log("leave details", leave)
    navigate(`/leave-profile/${leave.id}`, {
      state: { leaveData: leave },
    })
  }

  // Fetch leave data when component mounts
  useEffect(() => {
    fetchLeaves()
  }, [])

  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }

  // Table columns and rows configuration
  const tableDataConfig = {
    columns: [
      { label: "Start Date", field: "startDate", sort: "asc", width: 150 },
      { label: "End Date", field: "endDate", sort: "asc", width: 150 },
      { label: "Name", field: "name", sort: "asc", width: 150 },
      { label: "No. of Days", field: "noOfDays", sort: "asc", width: 150 },
      { label: "Status", field: "status", sort: "asc", width: 100 },
      { label: "Created At", field: "createdAt", sort: "asc", width: 200 },
      { label: "Updated At", field: "updatedAt", sort: "asc", width: 200 },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],
    rows: leaveData.map(leave => {
      const workingDays = getWorkingDays(
        leave.leave_startDate,
        leave.leave_endDate,
      )
      return {
        startDate: new Date(leave.leave_startDate).toLocaleDateString("en-IN"),
        endDate: new Date(leave.leave_endDate).toLocaleDateString("en-IN"),
        name: leave.doctor?.fname
          ? `${leave.doctor.fname} ${leave.doctor.lname ?? ""}`
          : "N/A",
        noOfDays: workingDays, // This will now display the working days excluding closed days
        status: leave.status,
        createdAt: new Date(leave.createdAt).toLocaleString("en-IN", options),
        updatedAt: new Date(leave.updatedAt).toLocaleString("en-IN", options),
        action: (
          <button
            className="btn btn-success"
            onClick={() => handleEditClick(leave)}
          >
            <FaRegEyeSlash size={20} />
          </button>
        ),
      }
    }),
  }

  return (
    <div>
      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <CardTitle className="h4">Leave List</CardTitle>
              {/* Add LeaveForm here if needed */}
              <LeaveForm refresh={fetchLeaves} />

              <MDBDataTable responsive bordered data={tableDataConfig} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default connect(null, { setBreadcrumbItems })(LeaveTable)
